// components/AdminRoute.tsx
// admin.readlinker.com 配下の /admin/* ルート用ガード。
// 未ログインならログイン画面へ、ログイン済みだがadminグループ非所属なら
// 「権限がありません」を表示し、両方満たせば子要素をそのまま描画する。
//
// これはUX用のガード（見た目の出し分け）であり、実際のセキュリティ境界は
// バックエンド（rl-api-18-adminのrequire_admin）側にある。

import React from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAuth } from '../context/AuthContext';
import { useAppTokens } from '../context/ThemeModeContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const TOKENS = useAppTokens();
  const { isLoggedIn, isAdmin } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: TOKENS.bg,
          color: TOKENS.text,
          textAlign: 'center',
          px: 3,
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 1 }}>権限がありません</Typography>
          <Typography sx={{ fontSize: 13, color: TOKENS.textSub }}>
            この画面はReadLinker管理者のみアクセスできます。
          </Typography>
        </Box>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
